import { useJoinCooperate } from '../cooperateModel'
import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function CooperateIntention() {
    const { loadData } = useJoinCooperate()
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
